import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=70401814&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=70401814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70401814",
  null
  
)

export default component.exports